import ApiService from "@/service/ApiService";

export default function useApi() {


  const getDatas = async () => {
    return await ApiService.get("get_id_card_departments");
  };

  const stoerData = async (data) => {
    return await ApiService.post("id_card_queue", data);
   };
 

  return {
    getDatas,
    stoerData
   
  };
}
